import { render } from "./TitleSlot.vue?vue&type=template&id=4080b6ce&scoped=true"
import script from "./TitleSlot.vue?vue&type=script&lang=js"
export * from "./TitleSlot.vue?vue&type=script&lang=js"

import "./TitleSlot.vue?vue&type=style&index=0&id=4080b6ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4080b6ce"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip});
